import * as angular from 'angular';

(function () {
    'use strict';
    angular.module('app').component('issueStatusComponent', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/parts/issue-status/issue-status.html'),
        controller: 'IssueStatusController',
        controllerAs: 'IssueStatusCtrl',
        bindings: {
            status: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/parts/issue-status/issue-status.component.ts